export const ADMIN_TITLE = "萝幼精选后台管理系统"
export const ADMIN_APPID = 1
export const IMAGE_CND_LINK= "https://ccwnu.vsghdeieussd.com"
export const VID_CND_LINK= "https://ccwnu.vsghdeieussd.com"